@if (sensor) {
    @switch (sensor.component) {
        @case ('DASHBOARD') {
         <nz-card
                [nzTitle]="(sensor.nameOnScreen || sensor.name) + (velocityReferenceValue ? ' - ' + velocityReferenceValue : '')"
                [style]="cardStyle"
                class="font-bold rounded-md h-full w-full"
            >
                <div class="h-full w-full flex flex-col justify-center items-center">

                    <p
                        [class]="'font-bold ' + (size && size === 'sm' ? 'dynamic-text-default-sm' : 'dynamic-text-default')"
                        [style]="'color: ' + getSensorColor(sensor.value ?? 0)"
                        style="font-size: 2.5rem;"
                    >
                        {{ (sensor.value ?? 0) + ' ' + (sensor.measurementUnit?.abbreviation ?? '') }}
                    </p>
                </div>
            </nz-card>
        }
        @default {
            <nz-card
                [nzTitle]="sensor.nameOnScreen || sensor.name"
                [style]="cardStyle"
                class="font-bold rounded-md h-full w-full"
            >
                <div class="h-full w-full flex flex-col justify-center items-center">

                    <p
                        [class]="'font-bold ' + (size && size === 'sm' ? 'dynamic-text-default-sm' : 'dynamic-text-default')"
                        [style]="'color: ' + getSensorColor(sensor.value ?? 0)"
                        style="font-size: 2.5rem;"
                    >
                        {{ (sensor.value ?? 0) + ' ' + (sensor.measurementUnit?.abbreviation ?? '') }}
                    </p>
                    <hr/>
                    @if (velocityReferenceValue !== '') {
                        <p
                            class="font-bold dynamic-text-default"
                            style="color: #3b82f6; font-size: 2.5rem;"
                        >
                            {{ velocityReferenceValue + ' ' + (sensor.measurementUnit?.abbreviation ?? '') }}
                        </p>
                        <span class="text-xs text-gray-500">Velocidad de referencia</span>
                    }
                </div>
            </nz-card>
        }
    }
}
